/** This component is not used anywhere */
import React, { useMemo } from "react";
import PropTypes from "prop-types";

import {
  InfiniteContainer,
  InfiniteElement,
  INFINITE_SCROLL_AXIS
} from "./container";

export { INFINITE_SCROLL_AXIS };
InfiniteScrollContainer.propTypes = {
  pageSize: PropTypes.number,
  elements: PropTypes.arrayOf(PropTypes.string),
  defaultPageHeight: PropTypes.string,
  itemRenderer: PropTypes.func,
  pageStyle: PropTypes.string,
  scrollOffset: PropTypes.number,
  scrollElemSelector: PropTypes.string,
  defaultPageWidth: PropTypes.string,
  axis: PropTypes.string
};
export function InfiniteScrollContainer({
  pageSize = 10,
  elements = [],
  defaultPageHeight = "20rem",
  defaultPageWidth = "20rem",
  itemRenderer = () => {},
  pageStyle,
  scrollOffset,
  scrollElemSelector,
  axis
}) {
  let pages = useMemo(
    function calculatePages() {
      return new Array(Math.ceil(elements.length / pageSize)).fill(1);
    },
    [elements, pageSize]
  );

  return (
    <InfiniteContainer
      scrollOffset={scrollOffset}
      scrollElemSelector={scrollElemSelector}
      axis={axis}
    >
      {(provided) => (
        <>
          {pages.map((el, i) => (
            <InfiniteElement
              key={i.toString()}
              itemId={i.toString()}
              minHeight={defaultPageHeight}
              minWidth={defaultPageWidth}
              pageStyle={pageStyle}
              {...provided}
            >
              {elements
                .slice(i * pageSize, i * pageSize + pageSize)
                .map((element, index) => (
                  <React.Fragment key={element.toString()}>
                    {itemRenderer({
                      element,
                      pageIndex: i,
                      elementIndex: pageSize * i + index
                    })}
                  </React.Fragment>
                ))}
            </InfiniteElement>
          ))}
        </>
      )}
    </InfiniteContainer>
  );
}
